const SetDualValue = "SetDualValue"
const SetNumValue = "SetNumValue"
const SetStringValue = "SetStringValue"
const GetInfo = "GetInfo"
const GetProperties = "GetProperties"
const SetProperties = "SetProperties"
const ApplyPatches = "ApplyPatches"
const GetLayout = "GetLayout"
export { GetLayout };
export { ApplyPatches };
export { SetProperties };
export { GetProperties };
export { GetInfo };
export { SetStringValue };
export { SetNumValue };
export { SetDualValue };